export default [
    {
        "ID":16,
        "Name":"Abdomen, pelvis & buttocks",
        "Sub":[
            {
                "ID":16,
                "Name":"Abdomen, pelvis & buttocks"
            },
            {
                "ID":7,
                "Name":"Arms & shoulder"
            },
            {
                "ID":15,
                "Name":"Chest & back"
            },
            {
                "ID":6,
                "Name":"Head, throat & neck"
            },
            {
                "ID":10,
                "Name":"Legs"
            },
            {
                "ID":17,
                "Name":"Skin, joints & general"
            }
        ]
    },
    {
        "ID":7,
        "Name":"Arms & shoulder",
        "Sub":[
            {
                "ID":48,
                "Name":"Arms general"
            },
            {
                "ID":30,
                "Name":"Finger"
            },
            {
                "ID":28,
                "Name":"Forearm & elbow"
            },
            {
                "ID":29,
                "Name":"Hand & wrist"
            },
            {
                "ID":26,
                "Name":"Upper arm & shoulder"
            }
        ]
    },
    {
        "ID":15,
        "Name":"Chest & back",
        "Sub":[
            {
                "ID":33,
                "Name":"Back"
            },
            {
                "ID":31,
                "Name":"Chest"
            },
            {
                "ID":32,
                "Name":"Lateral chest"
            }
        ]
    },
    {
        "ID":6,
        "Name":"Head, throat & neck",
        "Sub":[
            {
                "ID":23,
                "Name":"Face & eyes"
            },
            {
                "ID":22,
                "Name":"Forehead & head in general"
            },
            {
                "ID":21,
                "Name":"Hair & scalp"
            },
            {
                "ID":25,
                "Name":"Mouth & jaw"
            },
            {
                "ID":24,
                "Name":"Nose, ears, throat & neck"
            }
        ]
    },
    {
        "ID":10,
        "Name":"Legs",
        "Sub":[
            {
                "ID":44,
                "Name":"Foot"
            },
            {
                "ID":49,
                "Name":"Legs general"
            },
            {
                "ID":43,
                "Name":"Lower leg & ankle"
            },
            {
                "ID":41,
                "Name":"Thigh & knee"
            },
            {
                "ID":45,
                "Name":"Toes"
            }
        ]
    },
    {
        "ID":17,
        "Name":"Skin, joints & general",
        "Sub":[
            {
                "ID":47,
                "Name":"General, joints & other"
            },
            {
                "ID":46,
                "Name":"Skin"
            }
        ]
    }
];